import { createFileRoute } from '@tanstack/react-router'

import { LineItemImportDetailPage } from '@/pages/line-items/import/[id]/LineItemImportDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/line-items/import/$id/')(
  {
    component: LineItemImportDetailPage,
  },
)
